import { Route, AppId, createPageRoute } from '@lumapps/router';

const extensionsAnalyticsBaseRoute = 'analytics/extensions';
export const extensionsAnalyticsRouteMatcher = `/${extensionsAnalyticsBaseRoute}/*`;
export const extensionsAnalyticsRoutes: Route = createPageRoute({
    slug: `${extensionsAnalyticsBaseRoute}/:tab?`,
    id: 'extensions-analytics',
    appId: AppId.backOffice,
});

export const extensionsAnalytics = (tab?: string): Route => {
    return {
        ...extensionsAnalyticsRoutes,
        params: tab
            ? {
                  tab,
              }
            : undefined,
    };
};
